import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHAgrupamientoDel = async (credentials, data) => {
  const body = {
    service: "RNHAgrupamientoDel",
    params: {
      rnhAgrupamientoId: data?.id || null,
      rnhAgrupamientoVersion: data?.version ?? null,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};
